export const getImageDimension = (url: string) => new Promise<{
  width: number
  height: number
}>((resolve, reject) => {
  const img = new Image();
  img.onload = () => {
    resolve({
      width: img.naturalWidth,
      height: img.naturalHeight,
    });
  };
  img.onerror = (event, source, lineno, colno, error) => {
    reject(error);
  };
  img.src = url;
});
